import React, { useState } from 'react';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        department: '',
        doctor: '',
        message: ''
    });

    const [formErrors, setFormErrors] = useState({
        nameError: '',
        emailError: '',
        departmentError: '',
        doctorError: '',
        messageError: ''
    });

    const validateForm = () => {
        let isValid = true;
        const errors = {
            nameError: '',
            emailError: '',
            departmentError: '',
            doctorError: '',
            messageError: ''
        };

        if (formData.name.trim() === '') {
            errors.nameError = 'Por favor ingrese su nombre y apellido';
            isValid = false;
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(formData.email)) {
            errors.emailError = 'Por favor ingrese un email valido';
            isValid = false;
        }

        if (formData.department.trim() === '') {
            errors.departmentError = 'Por favor seleccione una opcion';
            isValid = false;
        }

        if (formData.doctor.trim() === '') {
            errors.doctorError = 'Por favor seleccione un doctor';
            isValid = false;
        }

        if (formData.message.trim() === '') {
            errors.messageError = 'Por favor escriba su mensaje';
            isValid = false;
        }

        setFormErrors(errors);
        return isValid;
    };

    const handleInputChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const isValid = validateForm();
        if (isValid) {
            // Handle form submission logic here
            console.log('Formulario enviado:', formData);
            // Reset form after submission if needed
            setFormData({
                name: '',
                email: '',
                department: '',
                doctor: '',
                message: ''
            });
        }
    };

    return (
        <form id="myForm" onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-lg-6 col-md-6 col-12 form_item">
                    <label>Nombre y Apellido</label>
                    <input
                        className="input-fild"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Nombre y Apellido"
                    />
                    <span className="error">{formErrors.nameError}</span>
                </div>
                <div className="col-lg-6 col-md-6 col-12 form_item">
                    <label>Tu Email</label>
                    <input
                        className="input-fild"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="Tu Email"
                    />
                    <span className="error">{formErrors.emailError}</span>
                </div>
                <div className="col-lg-6 col-md-6 col-12 form_item">
                    <label>Seleccione una opcion</label>
                    <select
                        name="department"
                        value={formData.department}
                        onChange={handleInputChange}
                        className="input-fild"
                    >
                        <option value="">Seleccione una opcion</option>
                        <option value="Paciente">Paciente</option>
                        <option value="Doctor">Doctor</option>
                    </select>
                    <span className="error">{formErrors.departmentError}</span>
                </div>
                <div className="col-lg-6 col-md-6 col-12 form_item">
                    <label>Seleccione un doctor</label>
                    <select
                        name="doctor"
                        value={formData.doctor}
                        onChange={handleInputChange}
                        className="input-fild"
                    >
                        <option value="">Seleccione un doctor</option>
                        <option value="Doctor 1">Dr. Juan Perez</option>
                        <option value="Doctor 2">Dr. Maria Gomez</option>
                        <option value="Doctor 3">Dr. Carlos Rodriguez</option>
                    </select>
                    <span className="error">{formErrors.doctorError}</span>
                </div>
                <div className="col-12 form_item">
                    <label>Escriba su mensaje</label>
                    <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        className="input-fild"
                        placeholder="Mensaje"
                    ></textarea>
                    <span className="error s2">{formErrors.messageError}</span>
                </div>
                <div className="col-12">
                    <input type="submit" className="theme-btn" value="Enviar Mensaje" />
                </div>
            </div>
        </form>
    );
};

export default ContactForm;
